module.exports = __webpack_public_path__ + "static/media/blob-1.9c17decc.svg";